import Route from '@ember/routing/route';
import { isTesting } from '@embroider/macros';
import { service } from '@ember/service';
import Utils from '../utils/utils';
import BrowserDetector from '../utils/browser-detector';
import ENV from '../config/environment';

export default class IndexRoute extends Route {
    @service('aditools-analytics') analytics;
    @service hashService;
    @service partData;
    @service hashDataService;
    @service plotDataService;
    @service tabService;
    @service urlData;
    @service intl;
    @service router;
    @service('aditools-site') siteconfig;
    @service('browser/window') window;

    beforeModel() {
        // Ensure the presence of the terminal slash in the URL.
        let url = this.window.location.href.split(/[?#]/)[0];
        if (url[url.length - 1] !== '/') {
            let newUrl =
                url +
                '/' +
                (this.window.location.search.length > 0 ? this.window.location.search : '') +
                (this.window.location.hash.length > 0 ? this.window.location.hash : '');
            this.window.history.replaceState({}, '', newUrl);
        }
        if (!BrowserDetector.isGood()) {
            this.router.transitionTo('browser');
            return;
        }
    }

    /**
     * Removed all of the logic from init and broke into separate lifecycle hooks
     * to enable the addition of separate routes
     */
    model(params) {
        return this._initializeApplication(params);
    }

    _initializeApplication(params) {
        let configData = Utils.getConfigData(params);
        return this.siteconfig
            .start(configData.url, configData.rootURL, configData.language, this.intl.locales)
            .then((/*site*/) => {
                this.intl.setLocale([this.siteconfig.FullLocale]);

                // Load partData, analytics, and hashService (url data).
                return this.partData.load().then((partData) => {
                    if (partData) {
                        this.urlData.load();
                        this.analytics.start(
                            ENV.toolname,
                            this.siteconfig.AnalyticsUrl,
                            false,
                            isTesting(),
                            ENV.environment === 'development',
                            null,
                        );
                        this.hashDataService.initializeData();
                        this.tabService.load(this.hashService.parsedLocationHash);
                        partData.isReady = true;
                        return partData;
                    }
                });
            });
    }
}
